import React from 'react'
import PropTypes from 'prop-types'
import GoogleInputField from './google-input-field.jsx'
import CounterField from './counter-field.jsx'
import Modal from './modal.jsx'
import MobileDropdown from './mobile-dropdown.jsx'
import DatePicker from './date-picker.jsx'
import { withTranslation as translate } from 'react-i18next'
import moment from 'moment'

function getDefaultModalStyle() {
  return {
    overlay: {
      display: 'hidden'
    },
    content: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      background: 'rgba(0, 0, 0, 0.0)',
      border: 'none',
      outline: 'none',
      padding: 0,
      margin: 0,
      boxSizing: 'content-box'
    }
  }
}

class SearchModal extends React.Component {
  render() {
    const t = this.props.t
    let modalContent = (
      <div className="search-modal d-flex flex-column justify-content-start align-items-stretch">
        <div className="title-bar">
          <div className="title">{t('general_edit')}</div>
          <button onClick={this.props.onRequestClose}>X</button>
        </div>
        <div className="content d-flex flex-column justify-content-start align-items-stretch">
          {this.props.showInputField ? (
            <GoogleInputField
              value={this.props.searchQuery}
              onChange={this.props.onSearchQueryChange}
              onReceivedSearchResults={this.props.onReceivedSearchResults}
              placeholder={t('landing_page_search_placeholder')}
              locale={this.props.locale}
            />
          ) : null}

          <MobileDropdown
            onChange={this.props.onChangeMobilityIcon}
            value={this.props.mobilityClass}
          />

          <DatePicker
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            onDatesChange={this.props.onDatesChange}
            smallScreen={true}
          />

          <CounterField
            postfix={'Guests'}
            onChange={this.props.onChangeNrGuests}
            value={this.props.nrGuests}
            minimumValue={1}
          />

          <button className="blue-large" onClick={this.props.onSearchClicked}>
            {t('general_search')}
          </button>
        </div>
      </div>
    )

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
        isLoading={this.props.isLoading}
        style={getDefaultModalStyle()}
      >
        {modalContent}
      </Modal>
    )
  }
}

SearchModal.propTypes = {
  onRequestClose: PropTypes.func,
  searchQuery: PropTypes.string,
  onSearchQueryChange: PropTypes.func,
  onReceivedSearchResults: PropTypes.func,
  t: PropTypes.func,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onSearchClicked: PropTypes.func,
  nrGuests: PropTypes.number,
  onChangeNrGuests: PropTypes.func,
  onDatesChange: PropTypes.func,
  onChangeMobilityIcon: PropTypes.func,
  startDate: PropTypes.objectOf(moment),
  endDate: PropTypes.objectOf(moment),
  mobilityClass: PropTypes.number,
  showInputField: PropTypes.bool
}

SearchModal.defaultProps = {
  showInputField: true
}

export default translate()(SearchModal)
